module.exports = "infobox"